import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import { useFormik } from 'formik';
/* import { usernameValidate } from '../../helper/validate' */
import { useAuthStore } from '../../store/store';
import { verifyPassword, getUser } from '../../helper/helper';
import './Login.scss';
import { featuresFlags } from '../../features/featuresFlags';
import SideBanner from '../../components/ui/SideBanner';

const EMAIL_EMPTY_MSG = 'Please enter your email!';
const EMAIL_INVALID_MSG = 'Please enter a valid email!';

const validateUsername = (username) => {
  if (!username) {
    return EMAIL_EMPTY_MSG;
  } else if (!/\S+@\S+\.\S+/.test(username)) {
    return EMAIL_INVALID_MSG;
  }
  return null;
};

const validatePassword = (password) => {
  if (!password) {
    return 'Password is required';
  } else if (password.length < 8) {
    return 'Password must be at least 8 characters';
  }
  return null;
};

const Login = () => {
  const setUsername = useAuthStore((state) => state.setUsername);
  const navigate = useNavigate();
  const [focusedInput, setFocusedInput] = useState(null);
  const [disabled, setDisabled] = useState(false);

  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };

  const handleBlur = () => {
    setFocusedInput(null);
  };
  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validate: (values) => {
      const errors = {};
      const { username, password } = values;

      errors.username = validateUsername(username);
      if (!errors.username) {
        errors.password = validatePassword(password);
      }

      Object.entries(errors).forEach(([key, error]) => {
        if (error) {
          toast.error(error, { id: `error-${key}` });
        }
      });

      if (!errors.username && !errors.password) {
        return null;
      }
      return errors;
    },
    /* validate: usernameValidate, */
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      setDisabled(true);
      setUsername(values.username);

      let data = getUser({ username: values.username });
      data.then(async (res) => {
        let apiData = res.data;
        if (apiData?.firstLogin === 'true') {
          localStorage.setItem('username', values.username);
          navigate('/recovery', { state: { firstTimeLogin: true } });
        } else {
          if (apiData?.employmentStatus === 'Active') {
            try {
              // Await the API call so errors can be caught properly
              let res = await verifyPassword({
                username: values.username,
                password: values.password,
              });

              let { token } = res.data;

              localStorage.setItem('token', token);
              localStorage.setItem('username', values.username);
              localStorage.setItem('user_data', JSON.stringify(apiData));

              toast.success(<b>Login Successfully...!</b>);

              // Navigate based on role
              setTimeout(() => {
                if (apiData.role === 'employee') {
                  window.location.pathname = featuresFlags.SINGLE_DASHBOARD
                    ? '/dashboard'
                    : '/employee';
                } else if (apiData.role === 'admin') {
                  window.location.pathname = featuresFlags.SINGLE_DASHBOARD
                    ? '/dashboard'
                    : '/admin';
                } else if (apiData.role === 'manager') {
                  window.location.pathname = featuresFlags.SINGLE_DASHBOARD
                    ? '/dashboard'
                    : '/manager';
                }
              }, 400);
            } catch (error) {
              console.error('Login Error:', error);

              // Show a user-friendly error message
              toast.error(<b>Username or Password does not Match!</b>);
            }
          } else {
            toast.error('User not Found');
          }
        }
      });
      setTimeout(() => {
        setDisabled(false);
      }, 3000);
    },
  });

  function handleRecovery() {
    const username = formik.values.username;
    const validationError = validateUsername(username);

    if (validationError) {
      toast.error(validationError, { id: 'error-username' });
    } else {
      localStorage.setItem('username', username);
      setUsername(username);
      navigate(`/recovery`);
    }
  }
  return (
    <div className="container">
      <Toaster
        position="top-center"
        reverseOrder={false}
        /* toastOptions={{ duration: 1000 }} */ gutter={4}
      ></Toaster>
      <SideBanner />
      <form className="right" onSubmit={formik.handleSubmit}>
        <div className="main">
          <h3 className="heading">Login</h3>
          <div className="inputs">
            <label htmlFor="email">Email</label>
            <input
              {...formik.getFieldProps('username')}
              onFocus={() => handleFocus('username')}
              style={{
                borderColor: focusedInput === 'username' ? 'green' : 'rgb(99 102 241)',
              }}
              type="text"
              id="email"
              autoComplete="on"
              onBlur={handleBlur}
              placeholder="Username"
            />
            <label htmlFor="pass">Password</label>
            <input
              id="pass"
              {...formik.getFieldProps('password')}
              onFocus={() => handleFocus('password')}
              style={{
                borderColor: focusedInput === 'password' ? 'green' : 'rgb(99 102 241)',
              }}
              autoComplete="on"
              type="password"
              onBlur={handleBlur}
              placeholder="Password"
            />
          </div>
          <div className="remember-me--forget-password">
            <p>
              <button type="button" className="recover" to="/recovery" onClick={handleRecovery}>
                Forgot Password?
              </button>
            </p>
          </div>
          <div className="submitbutton">
            <button disabled={disabled} type="submit">
              Login
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Login;
